export class LocationManagementCollections {
  static ModuleName = 'area-lookups';

  static Countries = `${LocationManagementCollections.ModuleName}/countries`;
  static country(countryId: string) {
    return `${LocationManagementCollections.Countries}/${countryId}`;
  }

  static countryGeographicalZones(countryId: string) {
    return `${LocationManagementCollections.country(countryId)}/geographical-zones`;
  }

  static countryStates(countryId: string) {
    return `${LocationManagementCollections.country(countryId)}/states`;
  }

  static GeographicalZones = `${LocationManagementCollections.ModuleName}/geographical-zones`;
  static geographicalZone(geographicalZoneId: string) {
    return `${LocationManagementCollections.GeographicalZones}/${geographicalZoneId}`;
  }

  static States = `${LocationManagementCollections.ModuleName}/states`;
  static state(stateId: string) {
    return `${LocationManagementCollections.States}/${stateId}`;
  }

  static stateCities(stateId: string) {
    return `${LocationManagementCollections.state(stateId)}/cities`;
  }

  static Cities = `${LocationManagementCollections.ModuleName}/cities`;
  static city(cityId: string) {
    return `${LocationManagementCollections.Cities}/${cityId}`;
  }

  static cityDistricts(cityId: string) {
    return `${LocationManagementCollections.city(cityId)}/districts`;
  }

  static Districts = `${LocationManagementCollections.ModuleName}/districts`;
  static district(districtId: string) {
    return `${LocationManagementCollections.Districts}/${districtId}`;
  }
}
